var nextPage = 2;
const container = document.getElementById('cars-wrapper');
const offersCount = document.getElementById('offers-count');
const offersCountMobile = document.getElementById('offers-count-mobile');
var button = document.getElementById('load-new-cars');

button.addEventListener('click', function(e) {
    e.preventDefault();
    // const button = this;
    let xhr = new XMLHttpRequest();
    let url = new URL(window.location.origin+window.location.pathname+"/fetch");
    url = addGetParamsToUrl(url);
    url += '&page=' + nextPage
    console.log(url);
    xhr.open("GET", url);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();

    xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            let response = JSON.parse(xhr.response);
            ++nextPage
            container.innerHTML += response.carsHtml;
            if(maxPages < nextPage) {
                button.classList.add('dnone');
            } else {
                button.classList.remove('dnone');
            }
            document.dispatchEvent(new Event('loadedNewImages'));
        }
    };
})


const catalogFilterForm = document.getElementById('catalog-filter-form')
catalogFilterForm.querySelectorAll('input')?.forEach(item => {
    item.addEventListener('change', updateCards)
})

function updateCards(e) {
    var actAddress = new URL(window.location.origin+window.location.pathname+"/fetch");

    actAddress = addGetParamsToUrl(actAddress);
    var xhr = new XMLHttpRequest()
    xhr.open('GET', actAddress, true);
    console.log(actAddress);
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();

    xhr.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
            let response = JSON.parse(xhr.response);
            nextPage = 2;
            container.innerHTML = response.carsHtml;
            offersCount.innerHTML = response.total;
            offersCountMobile.innerHTML = response.total;
            maxPages = response.last_page;
            if(maxPages < nextPage) {
                button.classList.add('dnone');
            } else {
                button.classList.remove('dnone');
            }
            document.dispatchEvent(new Event('loadedNewImages'));
        }
    };
}
function addGetParamsToUrl(actAddress) {
    var params  = new FormData(catalogFilterForm);
    var firstRun = true;
    for (var key of params.keys())
    {
        if (firstRun)
        {
            actAddress += '?';
            firstRun = false;
        }
        else actAddress += '&';
        actAddress += key + "=" + params.get(key);
    }

    return actAddress;
}

const brandSelect = document.querySelectorAll('.select-mark input[type="checkbox"]');
const modelsWrapp = document.querySelector('.select-model');
var activeBrands = [];
brandSelect?.forEach(brand => {
    brand.addEventListener('change', brandChange)
})
function brandChange(e) {
    if(this.checked) {
        activeBrands.push(this.value)
    } else {
        activeBrands.splice(activeBrands.indexOf(this.value), 1);
    }

    updateModels()
}
function updateModels() {
    if(activeBrands.length <= 0) {
        modelsWrapp.querySelectorAll('.select-model-section')?.forEach(item => {
            item.classList.remove('dnone')
                
            updateInputs(item, false);
            item.querySelector('.select__item')?.dispatchEvent(new Event('click'));
        })
        return;
    }
    modelsWrapp.querySelectorAll('.select-model-section')?.forEach(item => {
        item.classList.add('dnone')
        updateInputs(item, true);
    })
    for(let i = 0; i < activeBrands.length; ++i) {
        let brandId = activeBrands[i]
        let brandModels = modelsWrapp.querySelector('.brand-' + brandId)
        brandModels.classList.remove('dnone')
        updateInputs(brandModels, false);
        if(i == activeBrands.length - 1) {
            brandModels.querySelector('.select__item').dispatchEvent(new Event('click'));
        }
        
    }
    
}
function updateInputs(item, disabled) {
    item.querySelectorAll('input.checkbox')?.forEach(input => {
        input.disabled = disabled;
    })
}
document.querySelector('.catalog-another-clear')?.addEventListener('click', () => {
    activeBrands = [];
    updateModels();
})